module.exports = __webpack_public_path__ + "static/stava_ipad_3-19972d18e2235be696258370ca37d810.png";